import browser from 'detect-browser'

export function getBrowserVersion() {
  console.log(browser.name)
  console.log(browser.version)
  if (browser && browser.name && browser.version) {
    return `${browser.name} ${browser.version}`
  }
  return 'Undetectable browser'
}

export function isThisBrowserSupported() {
  switch (browser.name) {
    case 'chrome':
      return (browser.version > '47' || browser.version > '100')
    case 'firefox':
      return (browser.version > '32' || browser.version > '100')
    case 'opera':
      return (browser.version > '32' || browser.version > '100')
    case 'ie':
    case 'edge':
      return browser.version.substring(0, 1) === '1' && browser.version > '11'
    case 'safari':
    case 'mobile safari':
    case 'ios':
      return browser.version > '7'
    default:
      return false
  }
}



// WEBPACK FOOTER //
// ./src/browser-detect.js